import { CHECK_PAYMENT_INTENT, CHECK_PAYMENT_INTENT_FAILURE, CHECK_PAYMENT_INTENT_SUCCESS, CREATE_OPAY_PAYMENT, CREATE_OPAY_PAYMENT_FAILURE, CREATE_OPAY_PAYMENT_SUCCESS, CREATE_PAYMENT_INTENT, CREATE_PAYMENT_INTENT_FAILURE, CREATE_PAYMENT_INTENT_SUCCESS, DISABLE_CART, ENABLE_CART, RESET_CART, RESET_PAYMENT, UPDATE_PAYMENT_INTENT, UPDATE_PAYMENT_INTENT_FAILURE, UPDATE_PAYMENT_INTENT_SUCCESS } from "../ActionTypes";


const INIT_STATE = {
    paymentLoading:false,
    createdPayment:false,
    creatingPaymentIntent:false,
    createdPaymentIntent:false,
    gettingPaymentIntent:true,
    getPaymentIntent:{},
    updatingPaymentIntent:false,
    updatedPaymentIntent:false,
    isCartDisabled: false,
};
function PaymentReducer(state = INIT_STATE, action) {
    switch (action.type) {
        
        case CREATE_OPAY_PAYMENT: {
            // debugger
            return {
                ...state,
                paymentLoading:true,
                createdPayment:false,
            }
        }
        case CREATE_OPAY_PAYMENT_SUCCESS: {
            // debugger
            return {
                ...state,
                paymentLoading:false,
                createdPayment:true,
            };
        }
        case CREATE_OPAY_PAYMENT_FAILURE: {
            return {
                ...state,
                paymentLoading:false,
                createdPayment:false,
            };
        }
        case CREATE_PAYMENT_INTENT: {
            return {
                ...state,
                creatingPaymentIntent:true,
                createdPaymentIntent:false,
            };
        }
        case CREATE_PAYMENT_INTENT_SUCCESS: {
            return {
                ...state,
                creatingPaymentIntent:false,
                createdPaymentIntent:true,
                isCartDisabled:true
            };
        }
        case CREATE_PAYMENT_INTENT_FAILURE: {
            return {
                ...state,
                creatingPaymentIntent:false,
                createdPaymentIntent:false,
            };
        }
        case UPDATE_PAYMENT_INTENT: {
            return {
                ...state,
                updatingPaymentIntent:true,
                updatedPaymentIntent:false,
            };
        }
        case UPDATE_PAYMENT_INTENT_SUCCESS: {
            return {
                ...state,
                updatingPaymentIntent:false,
                updatedPaymentIntent:true,
            };
        }
        case UPDATE_PAYMENT_INTENT_FAILURE: {
            return {
                ...state,
                updatingPaymentIntent:false,
                updatedPaymentIntent:false,
            };
        }
        case CHECK_PAYMENT_INTENT: {
            return {
                ...state,
                gettingPaymentIntent:true,
                getPaymentIntent:{},
            };
        }
        case CHECK_PAYMENT_INTENT_SUCCESS: {
            return {
                ...state,
                gettingPaymentIntent:false,
                getPaymentIntent:action.payload,
            };
        }
        case CHECK_PAYMENT_INTENT_FAILURE: {
            return {
                ...state,
                gettingPaymentIntent:false,
                getPaymentIntent:{},
            };
        }
       
        case RESET_PAYMENT: {
            return {
                ...state,
                paymentLoading:false,
                createdPayment:false,
                
            };
        }
        case RESET_CART: {
            return {
                ...state,
                isCartDisabled: false,
                
            };
        }
        case DISABLE_CART: {
            return {
                ...state,
                isCartDisabled: true,
                
            };
        }
        case ENABLE_CART: {
            return {
                ...state,
                isCartDisabled: false, 
            };
        }
        
        default:
            return state;
    }
}
export default PaymentReducer;

export const getPaymentReducer = state => state.paymentReducer